import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToSection } from "@/lib/api";

const LINKS = [
  ["#scoreboard", "SCOREBOARD"],
  ["#highlights", "HIGHLIGHTS"],
  ["#dugout", "DUGOUT"],
  ["#recaps", "RECAPS"],
  ["#how-i-do-it", "HOW I DO IT"],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#050505]/85 backdrop-blur-md">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <a
          href="#mound"
          data-testid="nav-logo"
          onClick={(e) => go(e, "#mound")}
          className="font-bebas text-2xl tracking-wide"
        >
          BIG CAL <span className="text-neon">#50</span>
        </a>
        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map(([id, label]) => (
            <a
              key={id}
              href={id}
              data-testid={`nav-link-${label.toLowerCase().replaceAll(" ", "-")}`}
              onClick={(e) => go(e, id)}
              className="font-jbmono text-[11px] tracking-[0.2em] text-white/60 transition-colors hover:text-neon"
            >
              {label}
            </a>
          ))}
        </div>
        <button
          data-testid="nav-menu-button"
          onClick={() => setOpen(!open)}
          className="text-white/80 transition-colors hover:text-neon md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="flex flex-col gap-5 border-t border-white/10 bg-[#050505] px-6 py-6 md:hidden"
        >
          {LINKS.map(([id, label]) => (
            <a
              key={id}
              href={id}
              data-testid={`nav-mobile-link-${label.toLowerCase().replaceAll(" ", "-")}`}
              onClick={(e) => go(e, id)}
              className="font-bebas text-3xl tracking-wide text-white/80 transition-colors hover:text-neon"
            >
              {label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
